module.exports = __webpack_public_path__ + "static/media/marilyn-handout.88471b4b.pdf";